import { Drawer, Grid, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuLateral } from '../pages/MainMenuLateral';

export const LateralMenu = ({ openDrawer, setOpenDrawer, nombreCliente = 'Penya App' }) => {
    const [tokenusu, setTokenUsu] = useState(null);
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    useEffect(() => {
        const token = localStorage.getItem('DesRepresentante');
        setTokenUsu(token);
    }, []);

    useEffect(() => {
        const token = localStorage.getItem('DesRepresentante');
        setTokenUsu(token);
    }, [location]);

    const toggleDrawer = (open) => {
        setOpenDrawer(open);
    };

    const closeMobileDrawer = () => {
        if (isMobile) {
            setOpenDrawer(false);
        }
    };

    return (
        <>
            {tokenusu && (
                <>
                    {isMobile && (
                        <Drawer
                            anchor="left"
                            open={openDrawer}
                            onClose={() => toggleDrawer(false)}
                            transitionDuration={{
                                enter: 260,
                                exit: 190,
                            }}
                            ModalProps={{
                                keepMounted: true,
                            }}
                            PaperProps={{
                                className: 'side-drawer-paper',
                                sx: {
                                    width: 'auto',
                                    maxWidth: '92vw',
                                },
                            }}
                        >
                            <MenuLateral onNavigate={closeMobileDrawer} onClose={closeMobileDrawer} nombreCliente={nombreCliente} mobileDrawer />
                        </Drawer>
                    )}

                    {!isMobile && (
                        <Grid
                            container
                            className="fondo-lateralmenu"
                            size={{ xs: 12 }}
                        >
                            <MenuLateral nombreCliente={nombreCliente} />
                        </Grid>
                    )}
                </>
            )}
        </>
    );
};
